const jsEcommerce = {
    pjName: "JavaScript Ecommerce",
    pjdescrip: `This is the first project I created using JS, HTML, and LESS. It
      includes several key features, helping me gain practical
      experience in combining JavaScript, HTML, and LESS to create
      interactive and dynamic web components.`,
    techShare: [
      {
        childName: "Magnifying Glass Effect",
        features: [
          {
            web: "https://matt0244.github.io/jsEcommerce/",

            code: `
  function bigClassBind() {
    var smallPic = document.querySelector('#wrapper #content .contentMain #center #left #leftTop #smallPic');
    var leftTop = document.querySelector('#wrapper #content .contentMain #center #left #leftTop');
    var imagessrc = goodData.imagessrc;
  
    smallPic.onmouseenter = function () {
      var maskDiv = document.createElement('div');
      maskDiv.className = "mask";
      var BigPic = document.createElement('div');
      BigPic.id = "bigPic";
      var BigImg = document.createElement('img');
      BigImg.src = imagessrc[bigimgIndex].b;
      BigPic.appendChild(BigImg);
      smallPic.appendChild(maskDiv);
      leftTop.appendChild(BigPic);
  
      smallPic.onmousemove = function (event) {
        var left = event.clientX - smallPic.getBoundingClientRect().left - maskDiv.offsetWidth / 2;
        var top = event.clientY - smallPic.getBoundingClientRect().top - maskDiv.offsetHeight / 2;
  
        maskDiv.style.left = left + "px";
        maskDiv.style.top = top + "px";
  
        var scale = (smallPic.clientWidth - maskDiv.offsetWidth) / (BigImg.offsetWidth - BigPic.clientWidth);
        BigImg.style.left = -left / scale + 'px';
        BigImg.style.top = -top / scale + 'px';
      };
  
      smallPic.onmouseleave = function () {
        smallPic.removeChild(maskDiv);
        leftTop.removeChild(BigPic);
      };
    };
  }
  `,
            description:
              "This tutorial teaches you how to implement a magnifying glass effect where hovering over a product image shows an enlarged version of the product.",
            imageSrc: "/JS/MagnifyingGlass.png",
            imageAlt: "Magnifying glass effect on product image",
            codeHeading: "magnifyinGlass.js",
          },
        ],
      },
      {
        childName: "Breadcrumb navigation",
        features: [
          {
            code: `
  function navPathDataBind() {
    var navPath = document.querySelector('#wrapper #content .contentMain #navPath');
    var path = goodData.path; // Data from external source
  
    for (var i = 0; i < path.length; i++) {
      var aNode = document.createElement("a");
      aNode.innerText = path[i].title;
      if (i != path.length - 1) {
        aNode.href = path[i].url;
        var iNode = document.createElement('i');
        iNode.innerText = '/';
        navPath.appendChild(iNode);
      }
      navPath.appendChild(aNode);
    }
  }
  `,
            description:
              "This tutorial demonstrates how to dynamically render breadcrumb navigation based on data fetched from a source. This helps in rendering navigational paths for a product page dynamically.",
            imageSrc: "/JS/BreadcrumbNavigation.png",
            imageAlt: "Breadcrumb navigation",
            codeHeading: "breadcrumbNav.js",
          },
        ],
      },
      {
        childName: "Clickable Thumbnail Gallery",
        features: [
          {
            code: `
  function thumbnailClick() {
    var liNodes = document.querySelectorAll('#wrapper #content .contentMain #center #left #leftBottom #piclist ul li');
    var smallPic_img = document.querySelector('#wrapper #content .contentMain #center #left #leftTop #smallPic img');
    var imagessrc = goodData.imagessrc;
    smallPic_img.src = imagessrc[0].s;
  
    for (var i = 0; i < liNodes.length; i++) {
      liNodes[i].index = i;
      liNodes[i].onclick = function () {
        var idx = this.index;
        smallPic_img.src = imagessrc[idx].s;
      };
    }
  }
  `,
            description:
              "This tutorial covers how to implement a clickable thumbnail gallery. When a thumbnail is clicked, the corresponding larger image is displayed.",
            imageSrc: "/JS/Thumbnail.png",
            imageAlt: "Clickable thumbnail gallery",
            codeHeading: "clickableThumbGallery.js",
          },
        ],
      },
      {
        childName: "Product Price Calculation Based on Selected Features",
        features: [
          {
            code: `
  function changePriceBind(arr) {
    var oldPrice = document.querySelector('#wrapper #content .contentMain #center #right .rightTop .priceWrap .priceTop .price p');
    var price = goodData.goodsDetail.price;
  
    for (var i = 0; i < arr.length; i++) {
      if (arr[i]) {
        var changeprice = Number(arr[i].getAttribute('price'));
        price += changeprice;
      }
    }
  
    oldPrice.innerText = price;
  
    var leftprice = document.querySelector('#wrapper #content .contentMain .goodsDetailWrap .rightDetail .chooseBox .listWrap .left p');
    leftprice.innerText = '¥' + price;
  
    var ipts = document.querySelectorAll('#wrapper #content .contentMain .goodsDetailWrap .rightDetail .chooseBox .listWrap .middle li input');
    var newprice = document.querySelector('#wrapper #content .contentMain .goodsDetailWrap .rightDetail .chooseBox .listWrap .right i');
  
    for (var j = 0; j < ipts.length; j++) {
      if (ipts[j].checked) {
        price += Number(ipts[j].value);
      }
    }
  
    newprice.innerText = '¥' + price;
  }
  `,
            description:
              "This tutorial explains how to dynamically update the product price based on selected features like color or size.",
            imageSrc: "/JS/ProductPriceCalculation.png",
            imageAlt: "Price calculation based on selected features",
            codeHeading: "priceCalculation.js",
          },
        ],
      },
    ],
  };
  
  const wordPress = {
    pjName: "WordPress Projects",
    pjdescrip: `Over the years, I’ve had the privilege of working on diverse WordPress projects, from custom themes to complex plugin integrations. Below are some examples showcasing my expertise in WordPress development, customization, and design for various clients across different industries.`,
    techShare: [
      {
        childName: "Ruby Nail",
        features: [
          {
            web: "https://www.rubynails.com.au/",
            description:
              "Ruby Nails is a top nail salon in Australia, offering high-quality, stylish nail services tailored to each client for lasting beauty and confidence.",
            imageSrc: "/WordPress/ruby/rubynails1.png",
            imageAlt: "Ruby Nails is a top nail salon.",
          },
        ],
      },
      {
        childName: "Akimistu",
        features: [
          {
            web: "https://www.akimitsu.com.au/",
            description:
              "Akimitsu Australia specializes in authentic Japanese tempura dishes, bringing the rich flavors of traditional Japanese cuisine to Australia with fresh ingredients and expert preparation",
            imageSrc: "/WordPress/akimitsu/akimitsu1.png",
            imageAlt: "Akimitsu Australia",
          },
        ],
      },
      {
        childName: "Inesake",
        features: [
          {
            web: "https://www.inesake.com.au/",
            description:
              "Inesake offers premium sake, carefully curated to deliver the finest taste of Japanese tradition to Australia. Explore a range of high-quality sake for a true Japanese experience.",
            imageSrc: "/WordPress/inesake/inesake1.png",
            imageAlt: "Inesake",
          },
        ],
      },
      {
        childName: "Park Lok",
        features: [
          {
            web: "http://parklok.com.au/",
            description:
              "Park Lok is a restaurant in North Adelaide offering authentic Asian cuisine, specializing in Chiu Chow dishes. They provide both dine-in and delivery options, aiming to deliver a homely dining experience.",
            imageSrc: "/WordPress/parklok/parklok1.png",
            imageAlt: "Park Lok.",
          },
        ],
      },
      {
        childName: "SRH88",
        features: [
          {
            web: "https://srh88.com.au/",
            description:
              "SRH88 specializes in real estate development, construction, and investment. They offer personalized consulting solutions, focusing on turning visions into reality through efficient project management and expert consultation for land and property development.",
            imageSrc: "/WordPress/srh88/srh881.png",
            imageAlt: "SRH88",
          },
        ],
      },
      {
        childName: "YY Gem Land",
        features: [
          {
            web: "https://www.yygemland.com.au/",
            description:
              "YY Gem Land offers a selection of premium gemstones and jewelry. The store specializes in high-quality gems, including jade and various precious stones, with a focus on authenticity and craftsmanship.",
            imageSrc: "/WordPress/yygemland/yygemland1.png",
            imageAlt: "YY Gem Land.",
          },
        ],
      },
    ],
  };

  const reactProject = {
    pjName: "React.js Admin Dashboard",
    pjdescrip: `This project, built with React.js v18, Node.js, MongoDB Atlas, and Express, is deployed on AWS as a full-featured backend management system. It features secure user management (login, add, update, delete users), category management (add, update categories), product management (add, update, search, paginate products), and file handling (upload, delete images). Additionally, it includes role-based access control, dynamic permissions, and external API integrations like weather forecasting. The project is structured with React components, hooks, and state management, ensuring a scalable and maintainable solution.`,
    techShare: [
      {
        childName: "Live View",
        features: [
          {
            web: "http://3.27.181.176/",
            description:
              "This project uses Ant Design (antd) to create a modern, clean, and responsive interface, offering various pre-built components such as tables, forms, and modals for efficient UI development.",
            imageSrc: "/adminDashboard/Home.png",
            imageAlt: "Ant Design.",
          },
        ],
      },
      {
        childName: "Login & User Management",
        features: [
          {
            web: "https://github.com/Matt0244/react-js-admindashboard",
            description:
              "Secure login functionality, including features to add, update, and delete users, as well as retrieving a list of all users from the database.",
            imageSrc: "/adminDashboard/login.png",
            imageAlt: "Login and User Management.",
          },
        ],
      },
      {
        childName: "Category Management",
        features: [
          {
            web: "",
            description:
              "Allows the management of product categories, including adding new categories, updating existing ones, and retrieving both primary and secondary categories.",
            imageSrc: "/adminDashboard/categories.png",
            imageAlt: "Category Management.",
          },
        ],
      },
      {
        childName: "Product Management",
        features: [
          {
            web: "",
            description:
              "Handles product-related operations such as adding, updating, and listing products, including search and pagination features for enhanced user experience.",
            imageSrc: "/adminDashboard/Product-d.png",
            imageAlt: "Product Management.",
          },
        ],
      },
      {
        childName: "Image Upload & Management",
        features: [
          {
            web: "",
            description:
              "Provides features for uploading and managing product images, including the ability to upload, view, and delete images.",
            imageSrc: "/adminDashboard/Product.png",
            imageAlt: "Image Upload & Management.",
          },
        ],
      },
      {
        childName: "Role Management",
        features: [
          {
            web: "",
            description:
              "Includes functionality to manage roles and permissions, allowing you to create, update, and assign permissions to roles.",
            imageSrc: "/adminDashboard/role-addRole.png",
            imageAlt: "Role Management.",
          },
        ],
      },
      {
        childName: "Weather Information",
        features: [
          {
            web: "",
            description:
              "Fetches and displays real-time weather information through an API, providing support for JSONP requests.",
            imageSrc: "/adminDashboard/chart-pie.png",
            imageAlt: "Weather Information.",
          },
        ],
      },
    ],
  };

  const snakeGameProject = {
    pjName: "Snake Game",
    pjdescrip: `This is a classic Snake Game developed using TypeScript, HTML, and CSS. The game features essential snake mechanics, such as controlling the snake's head and body, generating random food, and a scoring system. Players control the snake using keyboard arrow keys, and when the snake eats food, it grows longer. The game also increases in difficulty as the player's score increases. It is designed for web display and includes a feature to share scores on social media.`,
    techShare: [
      {
        childName: "Game Home",
        features: [
          {
            web: "https://github.com/Matt0244/snake",

            description:
              "The game home includes the play area, a score panel, and a level panel. Players control the snake using arrow keys (up, down, left, right) to navigate the game area and try to eat food to grow.",
            imageSrc: "/JS/snake-1.png",
            imageAlt: "Game Home",
          },
        ],
      },
      {
        childName: "Trying to play",
        features: [
          {
            web: <a  href="https://matt0244.github.io/snake/"><button
           
            className="block  rounded-md bg-brand-blue px-3.5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-brand-lightBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-blue"
          >Click Me</button></a>,
            description:
              "Click the `Click Me`button to open a new window where you can play the classic Snake Game. In the pop-up window, you can control the snake using the arrow keys. Eat the food to grow the snake, increase your score, and level up. Enjoy the game in a dedicated space without distractions!",
            imageSrc: "/JS/snake-1.png",
            imageAlt: "Scoring and Level System",
          },
        ],
      },
      
      {
        childName: "Snake Control",
        features: [
          {
            web: "",
            description:
              "The snake is controlled using the keyboard's arrow keys. The snake moves one block at a time, and the game ends if the snake hits the walls. As the snake eats food, it grows longer, making the game more challenging.",
            imageSrc: "/JS/Snake.png",
            imageAlt: "Snake Control",
          },
        ],
      },
      {
        childName: "Food Generation",
        features: [
          {
            web: "",
            description:
              "Food is randomly generated within the game area. Players must guide the snake to eat the food. When the snake eats the food, the food reappears in a new location, and the player's score increases.",
            imageSrc: "/JS/snake-1.png",
            imageAlt: "Food Generation",
          },
        ],
      },
   
   
    ],
  };
  
  
  
  export { jsEcommerce, wordPress,reactProject,snakeGameProject };